// extracted by mini-css-extract-plugin
export var label = "_ho-2";
export var slideContainer = "_ho-0";
export var slider = "_ho-1";